import { useCallback, type FormEventHandler } from "react";

type FormRootProps = Omit<React.ComponentPropsWithoutRef<"form">, "onSubmit"> & {
  onSubmit?: FormEventHandler<HTMLFormElement>;
};

function FormRoot({ className, children, onSubmit, ...props }: FormRootProps) {
  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      event.stopPropagation();
      onSubmit?.(event);
    },
    [onSubmit],
  );

  return (
    <form className={className} onSubmit={handleSubmit} {...props}>
      {children}
    </form>
  );
}

export { FormRoot };
